import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { openSearchModalEvent } from '@root/features/services/search-pair'
import { SearchLoupeIcon } from '@root/shared/ui-kit'

export const HeaderSearchButton: React.FC = () => {
  const openSearch = useAction(openSearchModalEvent)

  return (
    <IconButton onClick={openSearch}>
      <SearchLoupeIcon size={16} />
    </IconButton>
  )
}

const IconButton = styled.div`
  display: grid;
  cursor: pointer;
  align-items: center;

  color: var(--text-9);
  transition: color 0.15s linear;

  &:hover {
    color: var(--text-10);
  }
`
